export default __webpack_public_path__ + "static/media/nose.18ce6202.png";